import React from "react";
import { Modal, Table, Empty, Typography, Tag } from "antd";
import { ClockCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { parseConfiguredMinutes } from "../../../../../utils/minGroundTimeUtils";

const { Title } = Typography;

/**
 * 最小过站时间查看组件
 * @param {Object} props
 * @param {boolean} props.visible - 是否显示对话框
 * @param {Function} props.onClose - 关闭对话框回调
 * @param {Object} props.airportConstraints - 机场约束信息对象
 */
const MinGroundTimeViewer = ({ visible, onClose, airportConstraints = {} }) => {
    // 将机场约束数据转换为数组以便在表格中展示
    const airportConstraintsList = Object.values(airportConstraints || {}).filter((airport) => airport && airport.iata_code);

    // 判断是否存在最小过站时间数据
    const hasGroundTimeData = airportConstraintsList.length > 0;

    // 表格列定义
    const columns = [
        {
            title: "机场",
            dataIndex: "iata_code",
            key: "iata_code",
            width: "15%",
            render: (text, record) => (
                <div>
                    <Tag color="blue">{text}</Tag>
                    <div>{record.airport_name || ""}</div>
                </div>
            ),
        },
        {
            title: "最小过站时间",
            dataIndex: "turnaround_time",
            key: "turnaround_time",
            align: "center",
            width: "30%",
            render: (time) => {
                const minutes = parseConfiguredMinutes(time);
                return (
                    <Tag color={minutes === null ? "red" : "orange"} style={{ fontSize: "14px" }}>
                        <ClockCircleOutlined style={{ marginRight: 4 }} />
                        {minutes === null ? "未配置" : `${minutes} 分钟`}
                    </Tag>
                );
            },
        },
        {
            title: "宵禁规则",
            key: "curfew",
            width: "45%",
            render: (_, record) => {
                const hasDep = record.dep_curfew_rules && record.dep_curfew_rules.length > 0;
                const hasArr = record.arr_curfew_rules && record.arr_curfew_rules.length > 0;

                if (!hasDep && !hasArr) {
                    return <span>无宵禁规则</span>;
                }

                return (
                    <>
                        {hasDep && (
                            <Tag color="red" style={{ marginRight: 4 }}>
                                有起飞宵禁规则
                            </Tag>
                        )}
                        {hasArr && <Tag color="green">有降落宵禁规则</Tag>}
                    </>
                );
            },
        },
        {
            title: "时区",
            dataIndex: "timezone",
            key: "timezone",
            width: "10%",
            render: (timezone) => timezone || "未设置",
        },
    ];

    return (
        <Modal
            title={
                <Title level={4} style={{ margin: 0 }}>
                    <ClockCircleOutlined style={{ marginRight: 8 }} />
                    机场最小过站时间
                </Title>
            }
            open={visible}
            onCancel={onClose}
            footer={null}
            width={800}
            className="ground-time-viewer"
        >
            {!hasGroundTimeData ? (
                <Empty description="未加载机场最小过站时间数据" />
            ) : (
                <>
                    <div style={{ marginBottom: 16 }}>
                        <Tag icon={<WarningOutlined />} color="warning">
                            确保航班计划中相邻航班的地面时间满足最小过站时间要求
                        </Tag>
                    </div>

                    <Table columns={columns} dataSource={airportConstraintsList} rowKey="iata_code" pagination={airportConstraintsList.length > 10 ? { pageSize: 10 } : false} size="middle" bordered />
                </>
            )}
        </Modal>
    );
};

export default MinGroundTimeViewer;
